import React from 'react';
import styles from '../Hero/Hero.module.css';

const Hero: React.FC = () => {
  return (
    <div className="">
      <div className={`${styles.bgimg}`}>
          <div className="container-fluid">
            <div className="row justify-content-end">
              <div className="col-12 col-lg-6 justify-content-center align-items-center d-flex flex-column text-center" style={{ height: '100vh' }}>
                  {/* <div className={styles.picTextContainer}                >
                  <h1 style={{ color: 'rgb(0, 0, 0)' }}>Bevisste smykker fra Maridalen</h1>
                  </div> */}
                <img
                  src="/logo_pvm.svg"
                  alt="Pearl Collection"
                  className={`img-fluid rounded shadow d-block mx-auto ${styles['hero-logo']}`}
                />
              </div>
            </div>
          </div>
          </div>
      <div className={`align-items-center d-flex flex-column text-center`} style={{height: '10vh', marginTop: '2em'}}>
          <div className={styles.textContainer}                >
                  <h1 style={{ color: 'rgb(0, 0, 0)' }}>Smykker med mening fra Maridalen</h1>
          </div>
      </div>
    </div>

  );
};

export default Hero;